import { useState } from 'react'
import { appAPI } from 'utils/app-api'

export const ApiTestPage = () => {
  const [results, setResults] = useState<Record<string, any>>({})
  const [loading, setLoading] = useState<Record<string, boolean>>({})

  const runTest = async (name: string, fn: () => Promise<any>) => {
    setLoading((prev) => ({ ...prev, [name]: true }))
    try {
      const result = await fn()
      setResults((prev) => ({ ...prev, [name]: { success: true, data: result } }))
    } catch (error: any) {
      setResults((prev) => ({ ...prev, [name]: { success: false, error: error.message } }))
    } finally {
      setLoading((prev) => ({ ...prev, [name]: false }))
    }
  }

  const tests = [
    {
      name: 'getAppVersion',
      fn: () => appAPI.getAppVersion(),
    },
    {
      name: 'getInstalledComponents',
      fn: () => appAPI.getInstalledComponents(),
    },
    {
      name: 'getAllVersionStates',
      fn: () => appAPI.getAllVersionStates(),
    },
    {
      name: 'getVersionStatus',
      fn: () => appAPI.getVersionStatus('test-version-id'),
    },
    {
      name: 'getVersionComponentsInstalled',
      fn: () => appAPI.getVersionComponentsInstalled('test-version-id'),
    },
  ]

  return (
    <div style={{ padding: '20px', fontFamily: 'monospace' }}>
      <h1>App API Test Page</h1>
      <p>Test all proxy API functions</p>

      <div style={{ display: 'flex', flexDirection: 'column', gap: '10px', marginTop: '20px' }}>
        {tests.map((test) => (
          <div key={test.name} style={{ border: '1px solid #ccc', padding: '10px', borderRadius: '4px' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <strong>{test.name}</strong>
              <button
                onClick={() => runTest(test.name, test.fn)}
                disabled={loading[test.name]}
                style={{
                  padding: '5px 15px',
                  cursor: loading[test.name] ? 'not-allowed' : 'pointer',
                }}
              >
                {loading[test.name] ? 'Running...' : 'Test'}
              </button>
            </div>

            {results[test.name] && (
              <div
                style={{
                  marginTop: '10px',
                  padding: '10px',
                  backgroundColor: results[test.name].success ? '#e6ffe6' : '#ffe6e6',
                  borderRadius: '4px',
                }}
              >
                <div>
                  <strong>Status:</strong> {results[test.name].success ? '✅ Success' : '❌ Error'}
                </div>
                <div style={{ marginTop: '5px' }}>
                  <strong>Result:</strong>
                  <pre style={{ margin: '5px 0', fontSize: '12px', overflow: 'auto' }}>
                    {JSON.stringify(
                      results[test.name].success ? results[test.name].data : results[test.name].error,
                      null,
                      2,
                    )}
                  </pre>
                </div>
              </div>
            )}
          </div>
        ))}
      </div>

      <div style={{ marginTop: '20px' }}>
        <button
          onClick={() => {
            tests.forEach((test) => runTest(test.name, test.fn))
          }}
          style={{ padding: '10px 20px', fontWeight: 'bold' }}
        >
          Run All Tests
        </button>
      </div>
    </div>
  )
}
